const swiper = new Swiper('.swiper', {
  slidesPerView: 1,

  // Optional parameters
  centeredSlides: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  }
});